import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { UserRoleEnum } from "../../../core-ui/core-ui.enums";
import { UserService } from "../../../core-ui/services/user.service";

/**
 * Allows the route only when the signed-in user has at least one of the given roles; otherwise
 * redirects to the welcome page. Must run after authAgentGuard, which sets the active user.
 *
 * The query params are copied from the target route because on a direct page load there is no
 * current url to merge from, and the welcome page needs `state` / `aid`.
 */
export const roleGuard =
  (...roles: UserRoleEnum[]): CanActivateFn =>
  (route) => {
    const user = inject(UserService).getActiveUser();

    if (user?.isAuthenticated() && roles.some((role) => user.hasRole(role))) {
      return true;
    }

    return inject(Router).createUrlTree(["/welcome"], {
      queryParams: route.queryParams,
    });
  };
